import NProgress from 'nprogress'; // Progress 进度条
import router, { createRouter, constantRouterMap } from '@/router';
import store from '@/store';
import auth from '@/utils/auth';
import { Message } from 'element-ui';

NProgress.inc(0.2);
NProgress.configure({ easing: 'linear', speed: 500, showSpinner: false });

// 路由钩子
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  // 判断url中是否有token
  const { token, staffCode } = to.query;
  // 存储基础信息
  if (token) {
    auth.removeAll();
    // 获取权限信息
    await store.dispatch('login/GetInfo', token);
    // 获取字典表信息
    await store.dispatch('login/GetDictionary');
    localStorage.setItem('token', JSON.stringify(token));
    // 用户名存到vuex
    store.dispatch('login/GetStaffInfo', staffCode);
    router.push('/index').catch(err => { console.log(err); });
  }
  const userInfo = localStorage.getItem('token');
  const dictionary = auth.getItem('dictionary');// 加载字典表
  const buttonList = auth.getItem('buttonList');// 加载按钮权限
  store.commit('login/SET_DICTIONARY', dictionary);
  store.commit('login/SET_BUTTONLIST', buttonList);
  if (userInfo) {
    // 配置动态路由【动态路由配置完毕，则不需要再配置】
    if (store.getters['permission/addRouters'].length !== 0) { // 第一此没有动态路由表  第二次就有了
      if (to.path === '/login') {
        if (store.getters['login/hasKongZhiTai']) {
          next({ path: `/homepage/home?redirect=${Math.random()}` });
        }
        next({ path: `/?redirect=${Math.random()}` });
      } else if (to.path === '/index') { // 进入 index 页面，判断有没有首页，有的话跳转到首页
        if (store.getters['login/hasKongZhiTai']) {
          next({ path: `/homepage/home?redirect=${Math.random()}` });
        } else {
          next();
          store.commit('navMenu/updateSelectKey', '');
          store.state.navTag.worktab.current = {};
        }
      } else {
        next();
        if (to.meta.dataKey) {
          store.dispatch('navTag/worktabRoute', {
            to: {
              name: to.name ? to.name : '',
              tabname: (to.meta && to.meta.title) ? to.meta.title : '',
              path: to.path,
              dataKey: (to.meta && to.meta.title) ? to.meta.dataKey : '',
            },
            from: {
              name: from.name ? from.name : '',
              tabname: (from.meta && from.meta.title) ? from.meta.title : '',
              path: from.path,
              dataKey: (from.meta && from.meta.title) ? from.meta.dataKey : '',
            },
          });
          localStorage.setItem('tag_list', JSON.stringify(store.getters['navTag/worktab']));
          store.commit('navMenu/updateSelectKey', to.meta.dataKey);
        } else {
          store.commit('navMenu/updateSelectKey', '');
        }
      }
    } else {
      store.commit('navTag/updateList', JSON.parse(localStorage.getItem('tag_list')) ? JSON.parse(localStorage.getItem('tag_list')) : []);
      const roles = auth.getItem('roles');
      if (roles.length === 0) {
        Message.error('该账号没有任何权限，请联系管理员！');
        auth.removeItem('userInfo');
        next({
          path: `/login?redirect=${Math.random()}`,
        });
        return;
      }
      store.commit('login/SET_USERINFO', userInfo);
      store.dispatch('permission/GenerateRoutes', { roles }).then(() => { // 根据roles权限生成可访问的路由表
        router.match = createRouter(constantRouterMap).match;
        router.addRoutes(store.getters['permission/addRouters']); // 动态添加可访问路由表
        router.addRoutes([{ path: '*', redirect: '/page404' }]); // 添加404路由匹配
        store.dispatch('navMenu/updateMenu', store.getters['permission/addRouters']);// 根据路由表生成需要的menus菜单
        next({ ...to }); // hack方法 确保addRoutes已完成 , replace: true 导航不会留下历史记录
      });
    }
  } else if (to.path === '/login') {
    next();
  } else if (to.path === '/entryRegistrationFormH5') {
    next();
  } else {
    next({
      path: `/login?redirect=${Math.random()}`,
    });
  }
});

// 关闭dialog
// function resetDialog() {
//   const modal = document.querySelector('.v-modal');
//   if (modal) {
//     modal.click();
//   }
//   const dialog = document.querySelector('.el-dialog__wrapper');
//   if (dialog) {
//     const result = window.getComputedStyle(dialog, null).getPropertyValue('display');
//     if (result !== 'none') {
//       const closeButton = document.querySelector('.el-dialog__close.el-icon.el-icon-close');
//       if (closeButton) {
//         closeButton.click();
//       }
//     }
//   }
// }

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  // resetDialog();
  NProgress.done();
});
